module.exports = __webpack_public_path__ + "static/media/animation-game-banner-mobile.e6a731da.jpg";